import { ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import Routers from './Routers';
import theme from './theme.css';
import { getData, getProviderOrder, logOut, saveDataIntoAsyncStore, setAppConfig, setCurrency, setProviderOrder } from './utils/commons';
import { paths, setGlobalHistory } from './config/router.config';
import wsclients from './services/wsclients'
import { connection, portalCfg } from './config';
import { useTranslation } from 'react-i18next';
import i18n from './translations/i18n';
import CustomAlert from './components/CustomAlert';
import { useHistory } from 'react-router-dom';
import { httpUtil } from './services/wsclients/httpUtil';
import { order_key, setOrderStatusCache } from './utils/order_cache';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#f8f8fb'
    },
    first_page: {
        display: 'flex',
    },
    loadingScreen: {
        minHeight: '100vh',

    },
    pageContainer: {
        height: window.innerHeight
    },
    pageBody: {
        flex: 'auto'
    },
    content: {
        flexGrow: 1,
    },
    logo: {
        width: 120,
    },
});

export default function App(props) {
    const history = useHistory();
    const classes = useStyles();
    const [message, setMessage] = useState({});
    const [ready, setReady] = useState(false);
    const [showLoading, setShowLoading] = useState(false);

    const { t } = useTranslation();

    useEffect(() => {
        setGlobalHistory(history);
        setupApp();
    }, []);

    // useEffect(() => {
    //     window.addEventListener("beforeunload", onClearCache);
    //     return () => {
    //         window.removeEventListener("beforeunload", onClearCache);
    //     };
    // }, []);

    const onClearCache = async (e) => {
        e.preventDefault();
        await logOut();
    };

    const setupApp = async () => {
        initLanguage();
        await setupChannel();
        await loadConfig();
        setCurrency(portalCfg.currencyDefault);
        setReady(true);
        await onLoad();
    }

    const initLanguage = () => {
        const language = getData('LANGUAGE');
        if (!language) {
            saveDataIntoAsyncStore('LANGUAGE', 'ENG');
            i18n.changeLanguage('ENG');
        }
    }

    const setupChannel = async () => {
        var key = await getData('API_KEY');
        var crmServer = await getData('CRM_SERVER');
        await wsclients.setupChannel({
            storeKVFn: async (key, value) => {
                saveDataIntoAsyncStore(key, value);
            },
            getKVFn: async (key) => {
                return getData(key);
            },
            sessionInvalidCallback: () => {
                logOut(true);
            },
            apiKey: key ? key : document._portalConfig.publicApiKey ? document._portalConfig.publicApiKey : "",
            host: crmServer ? crmServer : connection.server
        })
    }

    const loadConfig = async () => {
        setShowLoading(true);
        try {
            var result = await wsclients.config.getAppCfg(document._portalConfig.useCname ? null : document._portalConfig.applicationID, document._portalConfig.cname ? document._portalConfig.cname : window.location.host);
            console.log('load getAppCfg = ', result);
            if (result.code === 'OK') {
                var settings = result.data;
                if (document._portalConfig.useCname && settings.public_key) {
                    var crmServer = await getData('CRM_SERVER');
                    await wsclients.setupChannel({
                        storeKVFn: async (key, value) => {
                            saveDataIntoAsyncStore(key, value);
                        },
                        getKVFn: async (key) => {
                            return getData(key);
                        },
                        sessionInvalidCallback: () => {
                            logOut(true);
                        },
                        apiKey: settings.public_key,
                        host: crmServer ? crmServer : connection.server
                    })
                }

                setAppConfig(settings);
            } else {
                onShowMessage({ show: true, content: t('GET_CONFIG_FAIL') });
            }
        }
        catch (ex) {
            console.log("loadConfig exeption:", ex);
            onShowMessage({ show: true, content: t('GET_CONFIG_FAIL') });
        }
        setShowLoading(false);
    }

    const onShowMessage = (message) => {
        setMessage(message)
    }

    const onLoad = async () => {
        setShowLoading(true)
        const session = getData();
        if (session) {
            // httpUtil.startSession(session);
            let contact_info = await onLoadContact();
            console.log("contact_info==", contact_info);
            if (contact_info) {
                await onGetOrderStatus(contact_info.id);
            }
        }
        setShowLoading(false)
    }

    const onLoadContact = async () => {
        let contact_info = null;
        try {
            var result = await wsclients.contacts.getContact();
            if (result.code === 'OK') {
                contact_info = result.data;
                if (result.data && result.data.custom_fields && result.data.custom_fields.length > 0) {
                    let existProviderOrder = result.data.custom_fields.filter(x => x.key == 'provider_order');
                    if (existProviderOrder && existProviderOrder.length > 0) {
                        setProviderOrder(existProviderOrder[0].value);
                    }
                }
            }
        } catch (ex) {
            console.log("onLoadContact exception===", ex);
        }
        return contact_info;
    }

    const onGetOrderStatus = async (contact_id) => {
        try {
            let provider_order = getProviderOrder();
            var result = await wsclients.lab4services.getOrderStatus(contact_id, null, provider_order);
            console.log("result order status Appjs ===", result);
            if (result.code === 'OK') {
                if (result.data) setOrderStatusCache(order_key.order_status, JSON.stringify(result.data));
                let order_status = result.data;
                if (order_status) {
                    // if((order_status.status === 'VUMATEL_ORDER_EXCEPTION'))
                    //     history.push(paths.package_contact);
                    // else 
                    if (order_status.status === 'COMPLETE') {
                        let path = window.location.pathname;
                        console.log("path===", path);
                        if (path == paths.home || path == "/") { }
                        else if (path == paths.login) history.push(paths.home)
                        else { }
                    }
                }
            }
        } catch (ex) {
            console.log("onGetOrderStatus exception===", ex);
        }
    }

    if (ready) {
        return (
            <ThemeProvider theme={theme}>
                <div className={classes.root}>
                    <main className={classes.content}>
                        <Routers />
                    </main>
                </div>
            </ThemeProvider>
        )
    } else {
        return (
            <div>
                {message.show && <CustomAlert
                    open={message.show}
                    message={message.content}
                    showButtonClose={true}
                    onClose={() => onShowMessage({})}
                />}
            </div>
        )
    }
}
